import { BUSINESS, WA_LINKS } from "@/constants/site";

export default function Hero() {
  return (
    <section
      id="inicio"
      className="relative flex min-h-[100svh] w-full items-center justify-center overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Moody%20editorial%20photograph%20of%20an%20elegantly%20plated%20gourmet%20signature%20dish%20on%20a%20dark%20artisanal%20plate%20over%20a%20black%20table%20with%20warm%20candlelight%2C%20deep%20shadows%2C%20intimate%20fine%20dining%20restaurant%20atmosphere%2C%20rich%20warm%20earthy%20tones%2C%20soft%20golden%20highlights%2C%20shallow%20depth%20of%20field%2C%20luxurious%20and%20inviting&width=1600&height=1200&seq=clem-hero-autor&orientation=landscape"
        alt="Plato de autor de CLEM by Cerón presentado sobre una mesa oscura con luz cálida"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a1510]/75 via-[#0a1510]/55 to-[#16271C]/90" />

      <div className="relative z-10 flex w-full flex-col items-center px-4 py-24 text-center">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-peach/60 bg-black/30 px-4 py-2 text-[11px] font-medium uppercase tracking-[0.18em] text-peach">
          <i className="ri-restaurant-2-line" aria-hidden="true" />
          Cocina de autor · Armenia, Quindío
        </span>

        <h1 className="font-serif text-[3.25rem] leading-[1.02] text-cream sm:text-7xl md:text-8xl">
          CLEM <span className="text-peach">by Cerón</span>
        </h1>

        <p className="mt-6 max-w-xl font-serif text-lg italic leading-relaxed text-cream/90 md:text-2xl">
          {BUSINESS.slogan}
        </p>

        <div className="mt-9 flex w-full max-w-sm flex-col gap-3 sm:max-w-none sm:flex-row sm:justify-center">
          <a
            href={WA_LINKS.reservar}
            target="_blank"
            rel="noopener"
            className="inline-flex min-h-[52px] items-center justify-center gap-2 whitespace-nowrap rounded-md bg-wa px-7 text-base font-semibold text-white transition-colors hover:bg-[#1ebe5b]"
          >
            <i className="ri-whatsapp-fill text-lg" aria-hidden="true" />
            Escríbenos por WhatsApp
          </a>
          <a
            href="#ubicacion"
            className="inline-flex min-h-[52px] items-center justify-center gap-2 whitespace-nowrap rounded-md border border-peach px-7 text-base font-medium text-peach transition-colors hover:bg-peach hover:text-ink"
          >
            <i className="ri-map-pin-2-line text-lg" aria-hidden="true" />
            Cómo llegar
          </a>
        </div>
      </div>

      <a
        href="#nosotros"
        aria-label="Desliza para descubrir más"
        className="absolute bottom-6 left-1/2 z-10 flex h-11 w-11 -translate-x-1/2 items-center justify-center text-cream/80"
      >
        <i className="ri-arrow-down-line block animate-bounce text-2xl" aria-hidden="true" />
      </a>
    </section>
  );
}